<div #alertElement [ngClass]="['alert', type]" role="alert" [attr.data-tfa]="type">
  @if (type) {
    <div class="type-icon">
      @switch (type) {
        @case ('success') {
          <mat-icon data-tfa="check_circle">check_circle_outline</mat-icon>
        }
        @case ('info') {
          <mat-icon data-tfa="info">info_outline</mat-icon>
        }
        @case ('warning') {
          <mat-icon data-tfa="warning">warning_outline</mat-icon>
        }
        @case ('error') {
          <mat-icon data-tfa="highlight_off_outline">highlight_off_outline</mat-icon>
        }
      }
    </div>
  }
  @if (message) {
    <span class="message">{{message}}</span>
  }
  @if (messageTemplate) {
    <span>
      <ng-container [ngTemplateOutlet]="messageTemplate"></ng-container>
    </span>
  }

  @if (hasClosedButton) {
    <button mat-button class="close" data-dismiss="alert" data-tfa="Close" (click)="close()" aria-label="fermer">
      <mat-icon data-tfa="cancel">close</mat-icon>
    </button>
  }
</div>

